<template>
  <ul>
    <li v-for="(med, index) in medications" :key="(index+1)*new Date().getTime()" class="text-capitalize list__item">
      <span v-if="med.lo">{{med.lo}} - </span>
      <text-highlight :queries="keywords">{{med.desc}}</text-highlight>
      <div v-if="med.provider" class="list__sub-item">Provider:
        <router-link :to="{ name: 'ProviderNavigation', params: { specialty: getSpecialtyLink(med.provider.specialties[0].name), id: med.provider.id } }">
          {{ med.provider.lastName.toLowerCase() }}, {{ med.provider.firstName.toLowerCase() }}
        </router-link>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    name: "MedicationDetail",
    props: {
      medications: Array,
      keywords: Array,
    },
    methods: {
      getSpecialtyLink(specialty) {
        return specialty.toLowerCase().replace(/\s/g, '-');
      },
    }
  }
</script>

<style scoped lang="scss">
  $color-font: #58595b;
  ul {
    list-style-type: none;
    padding: 0;
  }
  .list__item {
    padding: 0.75em 1.25em;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    margin-bottom: 0.75em;
  }
  .list__sub-item {
    font-size: 0.85em;
    margin-top: 0.5em;
    color: $color-font;
  }
</style>